<div
  class="w-100 h-100"
  style="overflow-y: auto; overflow-x: hidden;"
  *ngIf="languages"
>
  <div
    *ngIf="kioskMode && !langFiltered"
    class="row justify-content-between h-100 kioskMode"
  >
    <div
      class="col-12 col-sm-3 d-flex align-items-center"
      style="flex-direction: column; justify-content: space-around"
    >
      <mat-card
        class="SquareLanguage bg-image-1"
        (click)="onClickLanguage(languages[0])"
      >
        <div class="langCode align-self-center">
          {{ languages[0]?.languageCode }}
        </div>
        <div class="langTxt">{{ languages[0]?.languageLabel }}</div>
      </mat-card>
      <mat-card
        class="SquareLanguage bg-image-2"
        (click)="onClickLanguage(languages[2])"
      >
        <div class="langCode align-self-center">
          {{ languages[2]?.languageCode }}
        </div>
        <div class="langTxt">{{ languages[2]?.languageLabel }}</div>
      </mat-card>
    </div>
    <div class="col-12 col-sm-6 p-4 d-flex align-items-center">
      <video class="w-100" autoplay loop muted oncanplay="this.play()" onloadedmetadata="this.muted = true">
        <source src="assets/img/AssurCard_Animation.webm" type="video/webm" />
      </video>
    </div>
    <div
      class="col-12 col-sm-3 d-flex align-items-center"
      style="flex-direction: column; justify-content: space-around"
    >
      <mat-card
        class="SquareLanguage bg-image-3"
        (click)="onClickLanguage(languages[1])"
      >
        <div class="langCode align-self-center">
          {{ languages[1]?.languageCode }}
        </div>
        <div class="langTxt">{{ languages[1]?.languageLabel }}</div>
      </mat-card>
      <mat-card
        class="SquareLanguage bg-image-4"
        (click)="onClickLanguage(languages[3])"
      >
        <div class="langCode align-self-center">
          {{ languages[3]?.languageCode }}
        </div>
        <div class="langTxt">{{ languages[3]?.languageLabel }}</div>
      </mat-card>
    </div>
  </div>

<div
  *ngIf="!kioskMode || langFiltered"
  class="language-container"
  style="background-color: white; height: 100%;"
>
  <div
    *ngFor="let language of languages; let i = index"
    (click)="onClickLanguage(language)"
  >
    <mat-card class="SquareLanguage w-100">
      <div class="langCode align-self-center">
        {{ language.languageCode }}
      </div>
      <div class="langTxt">
        {{ language.languageLabel }}
      </div>
    </mat-card>
  </div>
</div>
</div>